<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Account List">
	<ng-template appDialogBody>
		<div class="flex-none w-full pl-0 pr-0">
			<mat-form-field appearance="outline" class="mb-2 w-full">
				<mat-label>Find by account name or Salesforce record ID</mat-label>
				<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
				<input matInput type="text" placeholder="Find by account name or Salesforce record ID" [formControl]="filterAccount" />
				<button *ngIf="filterAccount.value" matIconButton class="mat-primary" matSuffix (click)="filterAccount.setValue('')">
					<fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
				</button>
			</mat-form-field>
		</div>

		<div class="table-scroll">
			<table class="relative si-table">
				<thead>
				<tr>
					<th class="align-middle bg-white border-t-0 sticky top-0"></th>
					<th class="width-40 align-middle bg-white border-t-0 sticky top-0">Account Name</th>
					<th class="width-20 align-middle bg-white border-t-0 sticky top-0">Website</th>
					<th class="width-20 align-middle bg-white border-t-0 sticky top-0">Salesforce Record ID</th>
					<th class="width-20 align-middle bg-white border-t-0 sticky top-0">Account Owner</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let account of accountsData">
					<td>
						<input type="radio" name="accountId" class="form-check-color-primary align-middle" [value]="account.id"  (click)="selectedAccount=account">
					</td>
					<td>
						<div>{{account.name}}</div>
					</td>
					<td>
						<a class="text-dark underline" target="_blank" href='http://{{account.website}}'>{{account.website}}</a>
					</td>
					<td>{{account.id}}</td>
					<td>{{account.ownerName}}</td>
				</tr>
				<tr *ngIf="!isLoading && accountsData.length === 0 && isDisplayNoAccountMessage">
					<td colspan="4" class="flex-none w-full text-center bg-white py-6 px-2">
						<i>No Accounts Found</i>
					</td>
				</tr>
				<tr *ngIf="isLoading">
					<td colspan="4" class="flex-none w-full text-center bg-white py-6 px-2">
						<div class="flex justify-center">
							<mat-spinner></mat-spinner>
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="onClose()">Cancel</button>
		<button matButton="filled" type="button" [disabled]="!selectedAccount" (click)="onSelectAccount(selectedAccount)">Assign</button>
	</ng-template>
</app-si-dialog>
